import { render, staticRenderFns } from "./MealType.vue?vue&type=template&id=6058794f&"
import script from "./MealType.vue?vue&type=script&lang=js&"
export * from "./MealType.vue?vue&type=script&lang=js&"
import style0 from "./MealType.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports